import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=42c2f0d5&scoped=true"
import script from "./IconClose.vue?vue&type=script&lang=js"
export * from "./IconClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2f0d5",
  null
  
)

export default component.exports